<template>
    <ul>
      <li class="completed" v-if="false">
        <em></em>
        <div class="status_list_cnt">
          <div class="status_title">
             <label>Started </label>
          </div>
          <span v-if="checkProperty( petition, 'createdOn')">{{ petition['createdOn'] | formatDateTime }}</span>
         </div>
      </li>
      <li class="completed">
        <em></em>
        <div class="status_list_cnt">
          <div class="status_title">
            <label> Case Created</label>
            <template v-if="false">
            <div class="info">
              <img src="@/assets/images/main/information.svg" />
              <div class="info_cnt">
                <p>Pending with {{ findUsers }}</p>
              </div>
            </div>
          </template>
          </div>
          <span v-if="checkProperty( petition, 'createdOn')">{{ petition['createdOn'] | formatDateTime }}</span>
        </div>
      </li>
      <!----current-->
      <li
          :class="{'completed':checkActivityCompleted('RFE_PREPARE_RESPONSE_DOCS'),'current':isCurrentActive('RFE_PREPARE_RESPONSE_DOCS') || !checkActivityCompleted('RFE_PREPARE_RESPONSE_DOCS') }"  >
        <em></em>
        <div class="status_list_cnt">
          <div class="status_title">
            <label>Response Docs Prepared</label>
            <template v-if="findUsers">
              <div class="info">
                <img src="@/assets/images/main/information.svg" />
                <div class="info_cnt">
                  <p>Pending with {{findUsers}}</p>
                </div>
              </div>
            </template>
          </div>
          <span v-if="getActionComplatedDate('RFE_PREPARE_RESPONSE_DOCS')">{{ getActionComplatedDate("RFE_PREPARE_RESPONSE_DOCS") | formatDateTime }}</span>
        </div>
      </li>
      <li v-if="checkWorkActivityisRequires('CASE_APPROVED')" :class="{'completed':checkActivityCompleted('CASE_APPROVED'),'current':isCurrentActive('CASE_APPROVED')&& checkActivityCompleted('RFE_PREPARE_RESPONSE_DOCS') }"  >
        <em></em>
        <div class="status_list_cnt">
          <div class="status_title">
            <label>Response Docs Approved</label>
            <template v-if="findUsers">
              <div class="info">
                <img src="@/assets/images/main/information.svg" />
                <div class="info_cnt">
                  <p>Pending with {{findUsers}}</p>
                </div>
              </div>
            </template>
          </div>
          <span v-if="getActionComplatedDate('CASE_APPROVED')">{{ getActionComplatedDate("CASE_APPROVED") | formatDateTime }}</span>
        </div>
      </li>
      <li
      :class="{'completed':checkActivityCompleted('REQUEST_PETITIONER_SIGN'),'current':isCurrentActive('REQUEST_PETITIONER_SIGN') }" 
      v-if="checkWorkActivityisRequires('REQUEST_PETITIONER_SIGN')">
        <em></em>
        <div class="status_list_cnt">
          <div class="status_title">
            <label>{{getTenantTypeId == 2?'Authorized Signature':'Petitioner Signature'}}</label>
            <template v-if="findUsers">
              <div class="info">
                <img src="@/assets/images/main/information.svg" />
                <div class="info_cnt">
                  <p>Pending with {{findUsers}}</p>
                </div>
              </div>
            </template>
          </div>
          <span v-if="getActionComplatedDate('REQUEST_PETITIONER_SIGN')">{{ getActionComplatedDate("REQUEST_PETITIONER_SIGN") | formatDateTime }}</span>
        </div>
      </li>
      <li :class="{'completed':checkActivityCompleted('SUBMIT_TO_USCIS'),'current':isCurrentActive('SUBMIT_TO_USCIS') }" >
        <em></em>
        <div class="status_list_cnt">
          <div class="status_title">
            <label>Filed with USCIS</label>
            <template v-if="findUsers">
              <div class="info">
                <img src="@/assets/images/main/information.svg" />
                <div class="info_cnt">
                  <p>Pending with {{findUsers}}</p>
                </div>
              </div>
            </template>
          </div>
          <span v-if="getActionComplatedDate('SUBMIT_TO_USCIS')">{{ getActionComplatedDate("SUBMIT_TO_USCIS") | formatDateTime }}</span>
        </div>
      </li>
      <li v-if="false" :class="{'completed':checkActivityCompleted('UPDATE_USCIS_RECEIPT_NUMBER'),'current':isCurrentActive('UPDATE_USCIS_RECEIPT_NUMBER') }" >
        <em></em>
        <div class="status_list_cnt">
          <div class="status_title">
            <label>Receipt Received</label>
            <template v-if="findUsers">
              <div class="info">
                <img src="@/assets/images/main/information.svg" />
                <div class="info_cnt">
                  <p>Pending with {{findUsers}}</p>
                </div>
              </div>
            </template>
          </div>
          <span v-if="getActionComplatedDate('UPDATE_USCIS_RECEIPT_NUMBER')">{{ getActionComplatedDate("UPDATE_USCIS_RECEIPT_NUMBER") | formatDateTime }}</span>
        </div>
      </li>
      <li :class="{'completed':checkActivityCompleted('FINAL_USCIS_STATUS'),'current':isCurrentActive('FINAL_USCIS_STATUS') }"  >
      
        <em></em>
        <div class="status_list_cnt" v-if="checkProperty(getupdatebenficiaryLog ,'data' ,'rfeNotice')">
        <div class="status_title">
          <template
            v-if="
              [
                'USCIS_APPROVED',
                'USCIS_RECEIVED_RFE',
                'USCIS_DENIED',
                'USCIS_WITHDRAWN',
              ].indexOf(checkProperty(getupdatebenficiaryLog['data'],'rfeNotice' ,'action')) > -1
            "
          >
            <label v-if="  checkProperty(getupdatebenficiaryLog['data'],'rfeNotice' ,'action') ==  'USCIS_APPROVED' "> Approved</label>
            <label v-if=" checkProperty(getupdatebenficiaryLog['data'],'rfeNotice' ,'action') == 'USCIS_RECEIVED_RFE'  "  > RFE Received</label>
            <label v-if=" checkProperty(getupdatebenficiaryLog['data'],'rfeNotice' ,'action') =='USCIS_DENIED'"> Denied</label>
            <label v-if="  checkProperty(getupdatebenficiaryLog['data'],'rfeNotice' ,'action') == 'USCIS_WITHDRAWN' " >  Withdrawn</label>
          </template>
          <template v-else><label>USCIS Response</label></template>
          <div class="info" v-if="isCurrentActive('FINAL_USCIS_STATUS') && findUsers && [50, 51].indexOf(getUserRoleId) <= -1">
              <img src="@/assets/images/main/information.svg" />
              <div class="info_cnt">
                <p>Pending with <a href="#"></a> {{ findUsers }}</p>
              </div>
            </div>
        </div>
      
        <span v-if="checkProperty(getupdatebenficiaryLog,'endedOn' )">{{checkProperty(getupdatebenficiaryLog,'endedOn' ) | formatDateTime}}</span>
          
      </div>
      <div class="status_list_cnt" v-else>
        
        <div class="status_title">
          <template
            v-if="
              [
                'USCIS_APPROVED',
                'USCIS_RECEIVED_RFE',
                'USCIS_DENIED',
                'USCIS_WITHDRAWN',
              ].indexOf(getPetitionDetails.curWorkflowActivity) > -1
            "
          >
            <label v-if="  checkProperty(getPetitionDetails, 'curWorkflowActivity') ==  'USCIS_APPROVED' "> Approved </label>
            <label v-if=" checkProperty(getPetitionDetails, 'curWorkflowActivity') == 'USCIS_RECEIVED_RFE'  "  > RFE Received</label>
            <label v-if=" checkProperty(getPetitionDetails, 'curWorkflowActivity') =='USCIS_DENIED'"> Denied</label>
            <label v-if="  checkProperty(getPetitionDetails, 'curWorkflowActivity') == 'USCIS_WITHDRAWN' " > Withdrawn</label>
          </template>
          <template v-else><label> USCIS Response</label></template>
          <div class="info" v-if="isCurrentActive('FINAL_USCIS_STATUS') && findUsers && [50, 51].indexOf(getUserRoleId) <= -1">
              <img src="@/assets/images/main/information.svg" />
              <div class="info_cnt">
                <p>Pending with <a href="#"></a> {{ findUsers }}</p>
              </div>
            </div>
        </div>

        <span v-if="getActionComplatedDate('UPDATE_USCIS_RESPONSE')">{{getActionComplatedDate("UPDATE_USCIS_RESPONSE") | formatDateTime}}</span>
          
      </div>
      </li>
    </ul>
  </template>
  
  <script>

  import moment from "moment";
  import _ from "lodash";
  export default {
    name: "caseStatusList",
    data: function () {
      return {
        
      }
     
    },
  
    methods: {
      getActionComplatedDate(code = "") {
      let returnValue = "";
      if (code) {
        let item = _.find(this.currentCaseDetails, { action: code });
        if (item && this.checkProperty(item, "endedOn")) {
          returnValue = item["endedOn"];
        }
      }
      return returnValue;
      },
      getActionStartdDate(code = "") {
        let returnValue = "";
        if (code) {
          let item = _.find(this.currentCaseDetails, { action: code });
          if (item && this.checkProperty(item, "startedOn")) {
            returnValue = item["startedOn"];
          }
        }
        return returnValue;
      },
     
    },
    mounted() {
    
    },
    props: {
      workFlowDetails: {
        type: Object,
        default: null,
      },
      petition: {
        type: Object,
        default: null,
      },
      currentCaseDetails: {
        type: Array,
        default: [],
      },
      scannedDocumentsList: {
        type: Array,
        default: [],
      },
    },
    computed: {
     

      checkWorkActivityisRequires(){
        return (code='')=>{
         
          if( _.has(this.workFlowDetails ,"config") && this.checkProperty(this.workFlowDetails ,'config', 'length')>0 ){
            let config = this.workFlowDetails['config'];
            let ilteredItem = _.find(config, {"code":code,"actionRequired":'Yes'});
            if(ilteredItem){
              return true;
            }
            return false;
            
            
          }else{
            return false;
          }
          
  
        }
      },
          
      checkAssignmentsExists(){
        let isAssignmentsExists =false
        if(this.workFlowDetails && _.has(this.workFlowDetails ,'config' )){
            let assignSuperVisorActiVity = _.find(this.workFlowDetails.config , {"code":'ASSIGN_SUPERVISOR' ,"include":'Yes'});
            let paralegalactiVity = _.find(this.workFlowDetails.config , {"code":'ASSIGN_PARALEGAL',"include":'Yes'});
            let attorneyactiVity = _.find(this.workFlowDetails.config , {"code":'ASSIGN_ATTORNEY',"include":'Yes'});
            let docm = _.find(this.workFlowDetails.config , {"code":'ASSIGN_DOCUMENTATION_MANAGER',"include":'Yes'});
            let doce = _.find(this.workFlowDetails.config , {"code":'ASSIGN_DOCUMENTATION_EXECUTIVE',"include":'Yes'});
            let caseApproved = _.find(this.workFlowDetails.config , {"code":'CASE_APPROVED',"include":'Yes'});
            
              if( assignSuperVisorActiVity  || paralegalactiVity || attorneyactiVity || docm  || caseApproved){
                isAssignmentsExists =true;
              }          
                      
  
              }
        return  isAssignmentsExists;
  
      },
  
      //currentCaseDetails
      checkActivityCompleted(){
        return (code='')=>{
         if( code == 'FINAL_USCIS_STATUS'){
          if( _.has(this.petition ,"completedActivities") &&
           (this.petition['completedActivities'].indexOf('USCIS_APPROVED') >-1 ||
           this.petition['completedActivities'].indexOf('USCIS_RECEIVED_RFE') >-1 ||
           this.petition['completedActivities'].indexOf('USCIS_DENIED') >-1 ||
           this.petition['completedActivities'].indexOf('USCIS_WITHDRAWN') >-1  )){
            return true;
          }else{
            return false;
          }
         }else{
          if( _.has(this.petition ,"completedActivities") && this.petition['completedActivities'].indexOf(code) >-1){
            return true;
          }else{
            return false;
          }
         }
         
          
  
        }
      },
      isCurrentActive() {
        var _self = this;
        return (item = "") => {
          switch (item) {
            case "RFE_PREPARE_RESPONSE_DOCS":
              var _ca = ["RFE_PREPARE_RESPONSE_DOCS" ];
              return (_self.petition["nextWorkflowActivity"] && _self.petition["nextWorkflowActivity"].some((r) => _ca.indexOf(r) >= 0 )) 
            case "CASE_APPROVED":
              var _ca = ["ASSIGN_SUPERVISOR","ASSIGN_PARALEGAL","ASSIGN_DOCUMENTATION_MANAGER",'ASSIGN_ATTORNEY',"CASE_APPROVED","RFE_REVIEW_RESPONSE_DOCS" ];
              return (_self.petition["nextWorkflowActivity"] && _self.petition["nextWorkflowActivity"].some((r) => _ca.indexOf(r) >= 0 )) 
            case "REQUEST_PETITIONER_SIGN":
              var _ca = ["REQUEST_PETITIONER_SIGN" ];
              return (_self.petition["nextWorkflowActivity"] && _self.petition["nextWorkflowActivity"].some((r) => _ca.indexOf(r) >= 0 )) 
            case "SUBMIT_TO_USCIS":
              var _ca = ["SUBMIT_TO_USCIS" ];
              return (_self.petition["nextWorkflowActivity"] && _self.petition["nextWorkflowActivity"].some((r) => _ca.indexOf(r) >= 0 )) 
            case "FINAL_USCIS_STATUS":
              var _ca = ["UPDATE_USCIS_RESPONSE","COURIER_TRACKING" ];
              return (_self.petition["nextWorkflowActivity"] && _self.petition["nextWorkflowActivity"].some((r) => _ca.indexOf(r) >= 0 )) 
            
              default:
              return false;
          }
  
          return false;
        };
      },
  
      findUsers() {
        let self = this;
        let returnVal = "";
        let allUsers = [];
        let selectedUsers = [];
        let filterItems = _.filter(this.currentCaseDetails, (item) => {
          return (
            !_.has(item, "endedOn") || item.endedOn == null || item.endedOn == ""
          );
        });
        if (self.checkProperty(filterItems, "length") > 0) {
          _.forEach(filterItems, (obj) => {
            if (self.checkProperty(obj, "users", "length") > 0) {
              let users = obj["users"];
              _.forEach(users, (user, ind) => {
                let userName = user["name"] + " (" + user["roleName"] + ")";
                if (selectedUsers.indexOf(user["_id"]) <= -1) {
                  allUsers.push(_.cloneDeep(userName));
                }
                selectedUsers.push(user["_id"]);
              });
            }
          });
        }
        if (allUsers.length > 0) {
          returnVal = allUsers.join(", ");
        }
        return returnVal;
      },
  
      getupdatebenficiaryLog(){
           let self =this;
           
          
           let benficiaryFinalLog =null;
           let tempBenficiaryFinalLog = [];
          
           _.forEach(this.currentCaseDetails,(item)=>{
                 if(['UPDATE_USCIS_RESPONSE' ].indexOf(item['action']) >-1){
  
  
                    if(_.has(item ,'endedOn') && item['endedOn'] && !this.checkProperty(item ,'ignore')){
  
  
                       
                     
                       if(_.has(item ,'endedOn') && item['endedOn']){
                          item['endedOn'] = moment(item['endedOn'])
     
                       }
                       if(_.has(item ,'startedOn') && item['startedOn']){
                          item['startedOn'] = moment(item['startedOn'])
     
  
                       }
                       if(self.checkProperty( item,'data' ,'rfeNotice')){
                       
  
  
                       //tempBenficiaryFinalLog
                       if( self.checkProperty(item, 'data','userCatergoryCode') =='beneficairy'){
                          tempBenficiaryFinalLog.push(item);
                       }
                    }
  
  
                      
                       
                      
                       //self.h4UscisLogs  = _.orderBy(self.h4UscisLogs ,['endedOn'] ,['desc'] );
                    }
                    
                    
                 }
            } );
         
            if(tempBenficiaryFinalLog.length>0){
              tempBenficiaryFinalLog  = _.orderBy(tempBenficiaryFinalLog ,['endedOn'] ,['desc'] );
              benficiaryFinalLog = tempBenficiaryFinalLog[0];
  
            }
            return benficiaryFinalLog;
            
  
        },
      
  
    },
  };
  </script>